export const AUTH_LOCAL_STORAGE_KEYS = {
  AUTH_TOKEN: 'AUTH_TOKEN',
  LANDING_SESSION_TOKEN: 'AUTH_LANDING_SESSION_TOKEN',
  USER: 'AUTH_USER',
  BRAND_ID: 'AUTH_BRAND_ID',
  TOKEN_EXPIRES_AT: 'AUTH_TOKEN_EXPIRES_AT',
  PUBLISH_ACCESS_TOKEN: 'AUTH_PUBLISH_ACCESS_TOKEN',
};

export const PROJECT_LOCAL_STORAGE_KEYS = {
  PROJECT_ID: 'PROJECT_ID',
  SECTION_ID: 'SECTION_ID',
  MODULE_ID: 'MODULE_ID',
};

export const BUILDER_INTERFACE_LOCAL_STORAGE_KEYS = 'BUILDER_INTERFACE';

export const DASHBOARD_LOCAL_STORAGE_KEYS = {
  SORT_BY: 'DASHBOARD_SORT_BY',
  SORT_ORDER: 'DASHBOARD_SORT_ORDER',
};
